import Stylus from './Stylus';

// Choose and place a template
class StylusTemplate extends Stylus {
  async activate() {
    super.activate();

    await this.controller.actionChooseTemplate();
  }

  iconClass() {
    return 'far fa-table-layout';
  }

  description() {
    return 'Template';
  }
}

export default StylusTemplate;
